import domWrap from "../utils/domWrap";
import http from "../utils/http";

export default async body => { // 'body'
	[...document.querySelectorAll('[searchkey]')].forEach(search => http('https://cse.google.com/cse.js?cx=' + search.getAttribute('searchkey')).script());
	[...document.querySelectorAll('[data-action="search"]')].forEach(search => search.addEventListener('click',e => {
		e.preventDefault();
		const 	parent = search.parentElement,
				/** @type {HTMLInputElement} */ 
				input = parent.querySelector('input[type="search"]');
		parent.classList.add('search-active');
		if(!input) return;
		input.focus();
		input.setAttribute('placeholder','Search');
		
	}));
	domWrap(body).on('click','.search-active',function(){
		this.querySelector('input[type="search"]')?.focus();
	})
	.on('click','.search-active .close',function(){
		this.closest('.search-active').classList.remove('search-active');
	});
};